import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
 state: {
  get_current_user_details: {},
  get_user_email: "",
  get_login_status: false,
  get_report_screenshot_url: "",
  get_issue_details: {},
  get_folder_item: {},
  get_Breadcrumbs_array: [],
  get_array_buffer: [],
 },
 getters: {
  get_current_user_details(state) {
   return state.get_current_user_details;
  },
  get_user_email(state) {
   return state.get_user_email;
  },
  get_report_screenshot_url(state) {
   return state.get_report_screenshot_url;
  },
  get_issue_details(state) {
   return state.get_issue_details;
  },
  get_folder_item(state) {
   return state.get_folder_item;
  },
  get_Breadcrumbs_array(state) {
   return state.get_Breadcrumbs_array;
  },
  get_login_status(state) {
   return state.get_login_status;
  },
  get_array_buffer(state) {
   return state.get_array_buffer;
  },
 },
 mutations: {
  SET_CURRENTUSER_DETAILS(state, set_current_user_details) {
   state.get_current_user_details = set_current_user_details;
  },
  SET_USEREMAIL(state, set_user_email) {
   state.get_user_email = set_user_email;
  },
  SET_LOGIN_STATUS(state, get_login_status) {
   state.get_login_status = get_login_status;
  },
  SET_REPORT_ISSUE_SREENSHOT_URL(state, set_report_screenshot_url) {
   state.get_report_screenshot_url = set_report_screenshot_url;
  },
  SET_ISSUE_DETAILS(state, set_issue_details) {
   state.get_issue_details = set_issue_details;
  },
  SET_FOLDER_ITEM(state, set_folder_item) {
   state.get_folder_item = set_folder_item;
  },
  SET_BREADCRUMBS_ARRAY(state, payload) {
   state.get_Breadcrumbs_array = payload;
  },
  SET_ARRAY_BUFFER(state, payload) {
   state.get_array_buffer = payload;
  },
 },
 actions: {},
 modules: {},
 plugins: [createPersistedState()],
});
